module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"send":"Send","errors":{"connection":"Can\u0027t register right now, please try later","message":{"required":"Message is required","string":"Please use only letters and numbers","min":"Message must be at least 2 letters"}}}}')
  delete Component.options._Ctor
}
